import { createAction, props } from '@ngrx/store';
import { QueryParams } from 'src/app/shared/interfaces/query-params';
import { IPaymentStatementsRequest, IPaymentStatementsResponse } from '../dto/statements.dto';

export const loadStatements = createAction('[Statement] Load Statements', props<{ request: IPaymentStatementsRequest }>());

export const loadStatementsSuccess = createAction('[Statement] Load Statements Success', props<{ response: IPaymentStatementsResponse }>());

export const loadStatementsFailure = createAction('[Statement] Load Statements Failure', props<{ error: Error | any }>());
